'use strict';

//
import '../css/normalize.css'
import './sui.css'
import './style.css'
import '../libs/device';
import '../core/prototype'

import React from 'react';
import ReactDom from 'react-dom';
import events from 'events'
import $ from 'jquery'
import classnames from 'classnames'
// 组件
import App from './app';
import Form from '../mobile/form';
import Loading from '../mobile/loading';
import Page from './page';
import Popup from '../mobile/popup';
import Filter from '../mobile/filter';
import Link from '../mobile/link';
import Image from '../mobile/image';
import Input from '../mobile/input'
import View from '../mobile/view';
import Switch from '../mobile/switch'
import Directive from '../mobile/directive'
import Timer from '../mobile/timer';
import Picker from '../mobile/picker'
import Lock from './lock';
import Title from './title';
import Calendar from './calendar'
// common
import Icon from '../common/icon';
import Upload from '../common/upload';
import Animate from '../common/animate';
import Slider from '../common/slider';
import Num from '../common/num';
import Iscroll from '../common/iscroll';
import Language from '../common/language'
import Fix from '../common/fix';
import Http from '../common/http';
import Cache from '../common/cahce';
import Waves from '../common/waves';
import If from '../common/if'
// core
import Component from '../core/component';
import Enhance from '../core/enhance';
import Validator from '../core/validator'
import Validate from '../core/validate'
// utils
import tools from '../libs/tools'
import device from '../libs/device'
//router
import Router from '../router/router';
import Route from '../router/route';
import RouteNav from '../router/route-nav';
import RouteLink from '../router/route-link';
import RouteSwitch from '../router/route-switch';
import RoutePopup from '../router/route-popup';
import RouteModal from '../router/route-modal';
import RouteRoot from '../router/route-root'
// decorators
import $event from '../decorators/$event';

let Mobile = {
    App,
    Icon,
    Form,
    Loading,
    Num,
    Page,
    Popup,
    Link,
    Image,
    Input,
    Language,
    Switch,
    View,
    Directive,
    Timer,
    Picker,
    // common
    Upload,
    Animate,
    Slider,
    Filter,
    Iscroll,
    Lock,
    Http,
    Fix,
    Title,
    Cache,
    Waves,
    If,
    Calendar,
    // core
    React,
    ReactDom,
    Component,
    Enhance,
    events,
    $,
    Validator,
    Validate,
    // utils
    tools,
    classnames,
    device,
    //
    Router,
    Route,
    RouteNav,
    RouteLink,
    RouteSwitch,
    RoutePopup,
    RouteModal,
    RouteRoot,
    $event,
    //
    version: '3.0.0'
};

export default Mobile;
